<div class="tag-pill" [attr.source]="tag.source">
    <div class="tag-content">
        <div class="tag-icon"></div>
        <div class="tag-description">{{getTagDescription()}}</div>
        <div class="tag-error-container" *ngIf="getErrors()">
            <div class="tag-error" *ngFor="let error of getErrors()">
                <span class="error-type">
                    {{error.type}}
                </span>:
                <span class="error-descr">
                    {{getDescription(error.descr)}}
                </span>
            </div>
        </div>
    </div>
</div>